import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import {
  fetchPipelinesList,
  fetchUserCurrentLocationData,
  verifyLoginTokenAdmin,
  verifyLoginTokenUser,
  consumePortalSsoTicket,
} from "../../Apis/User-Apis";
import {
  getLocalStorageJSON,
  removeLocalStorageJSON,
  setLocalStorageJSON,
} from "../../../Utils/localStorageFunc";

let searchParamsUser = {
  name: "India",
  code: "IN",
  currency: "INR",
  dial_code: "+91",
};

const initialState = {
  status: "loading",
  userData: null,
  UserCurrentLocationData: searchParamsUser,
  isOffline: false,
  userLoading : true,
  userLoggedInData: null,
  isUserLogin: false,
  isAdminLogin: false,
  showSignUpPopup: false,
  isSignUpCrossed: false,
  // "x" is the special "Global" pipeline option — not a real pipeline row, just
  // the default/no-pipeline-filter choice shown first in the selector. A
  // previously manually-chosen value persists in localStorage and wins over
  // this default (see Header.jsx, which also skips the country-based
  // auto-select when this is already present).
  selectedPipelineId: getLocalStorageJSON("selectedPipelineId") ?? "x",
  pipelinesList: [],
  // Mirrors Header.jsx's own local hasAutoSelectedPipeline flag into Redux — per explicit
  // instruction ("frontend se woh id lekar hi backend mein jao, search karne function tabhi
  // chalao"): a direct URL navigation straight to /flights/results (not via the Homepage flow)
  // could fire the initial search BEFORE Header's own country-based auto-select effect (which
  // needs an async pipelinesList fetch first) ever resolved selectedPipelineId off its "x"
  // default — silently running a Global search for a visitor whose country WAS correctly
  // detected, just not synced to selectedPipelineId yet (confirmed live: Country.name="India"
  // but pipeline_id="x" in the same request body). True immediately when a previous explicit
  // choice already exists in localStorage (same init check Header.jsx's own local flag uses —
  // nothing to wait for then); false otherwise until Header's effect actually runs once.
  pipelineAutoSelectResolved: getLocalStorageJSON("selectedPipelineId") != null,
};

// Async thunk to fetch user current location data
export const UserLocationFetcher = createAsyncThunk(
  "user/fetchUserLocationData",
  async () => {
    try {
      const response = await fetchUserCurrentLocationData();
      // The value we return becomes the `fulfilled` action payload
      return response;
    } catch (error) {
      console.log("the rror : ", error);
      throw error;
    }
  }
);

// Async thunk to fetch the pipelines list for the customer-facing selector
export const PipelinesListFetcher = createAsyncThunk(
  "user/fetchPipelinesList",
  async () => {
    return await fetchPipelinesList();
  }
);

export const AuthenticateUser = () => {
  return async (dispatch, getState) => {
    const statesData = getState();

    let { user } = statesData;

    let state = user;
    console.log("the states are  : ", state);

    let ul = getLocalStorageJSON("UL");
    let al = getLocalStorageJSON("AL");

    const urlParams = new URLSearchParams(window.location.search);

    const tk = urlParams.get("tk");

    // `tk` on the URL is a one-time SSO ticket (not the admin's real token — see
    // AdminController::createPortalSsoTicket). Exchange it server-side for a freshly
    // minted admin JWT; the ticket itself is consumed/invalidated on first use.
    let adminTicketChecker = async (ticket) => {
      let resp = await consumePortalSsoTicket(ticket);

      if (resp[0] == true) {
        dispatch(setUserLoggedInData(resp[1]));
        removeLocalStorageJSON("UL");
        setLocalStorageJSON("AL", resp[2]);
        dispatch(setisUserLogin(false));
        dispatch(setisAdminLogin(true));
        dispatch(setUserLoading(false));
        return true;
      }

      toast.error(resp[3] || "Authentication failed / expired. Please contact support for help.");
      return false;
    };

    console.log("ul is : ", ul);
    console.log("al is : ", al);

    // A `tk` on the URL always means "someone just clicked Visit Portal" — that must win over
    // whatever stale UL/AL a previous session (a different admin, or the same admin's earlier
    // visit) left behind in this browser's localStorage, otherwise this tab silently logs back
    // in as whoever was last authenticated here instead of the admin who just generated the
    // ticket. Check it first, unconditionally, before any existing-session auto-login.
    if (tk) {
      let move = await adminTicketChecker(tk);

      if (move == false) {
        removeLocalStorageJSON("UL");
        removeLocalStorageJSON("AL");
        dispatch(setisUserLogin(false));
        dispatch(setisAdminLogin(false));
        dispatch(setUserLoggedInData(null));
        // dispatch(setShowSignUpPopup(true));
        dispatch(setShowSignUpPopup(false));
        dispatch(setUserLoading(false))
      }
    } else if (ul == null && al == null) {
      // not login in past history
      removeLocalStorageJSON("UL");
      removeLocalStorageJSON("AL");
      dispatch(setisUserLogin(false));
      dispatch(setisAdminLogin(false));
      dispatch(setUserLoggedInData(null));
      dispatch(setUserLoading(false))
      // dispatch(setShowSignUpPopup(true));
      dispatch(setShowSignUpPopup(false));

      // User has not logged in before
    } else {
      // automatic login

      if (ul != null) {
        // call user authenticator

        const isTokenValid = await verifyLoginTokenUser(ul);
        console.log("isTokenValid is : ", isTokenValid);

        if (isTokenValid[0] == false) {
          // User has not logged in before
          if (!tk) {
            // dispatch(setShowSignUpPopup(true));
            dispatch(setShowSignUpPopup(false));
          }
          removeLocalStorageJSON("UL");
          removeLocalStorageJSON("AL");
          dispatch(setUserLoading(false));
        } else {
          dispatch(setisUserLogin(true));
          dispatch(setisAdminLogin(false));
          dispatch(setUserLoggedInData(isTokenValid[1]));
          dispatch(setUserLoading(false))
        }
      } else if (al != null) {
        // call admin authenticator

        const isTokenValid = await verifyLoginTokenAdmin(al);

        if (isTokenValid[0] == false) {
          if (!tk) {
            // dispatch(setShowSignUpPopup(true));
            dispatch(setShowSignUpPopup(false));
          }
          removeLocalStorageJSON("UL");
          removeLocalStorageJSON("AL");
          dispatch(setUserLoading(false));
        } else {
          dispatch(setisUserLogin(false));
          dispatch(setisAdminLogin(true));
          dispatch(setUserLoggedInData(isTokenValid[1]));
          dispatch(setUserLoading(false))
        }
      }
    }
  };
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // admina nd suer can login from same very end  ... on case of both logins create localstorage identifier AL / UL as true or false and authenticate through token by them

    setShowSignUpPopup: (state, action) => {
      state.showSignUpPopup = action.payload;
    },
    setUserLoggedInData: (state, action) => {
      state.userLoggedInData = action.payload;
    },
    setUserLoading: (state, action) => {
      state.userLoading = action.payload;
    },
    setisUserLogin: (state, action) => {
      state.isUserLogin = action.payload;
    },
    setisAdminLogin: (state, action) => {
      state.isAdminLogin = action.payload;
    },
    setSelectedPipelineId: (state, action) => {
      state.selectedPipelineId = action.payload;
    },
    setPipelineAutoSelectResolved: (state, action) => {
      state.pipelineAutoSelectResolved = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(UserLocationFetcher.pending, (state) => {
        state.status = "loading";
      })
      .addCase(UserLocationFetcher.fulfilled, (state, action) => {
        state.status = "idle";
        state.UserCurrentLocationData = {
          name: action.payload.country_name,
          code: action.payload.country,
          currency: action.payload.currency,
          dial_code: action.payload.country_calling_code,
        };
      })
      .addCase(UserLocationFetcher.rejected, (state, action) => {
        console.log("the erorr here is : ", action);
        state.status = "idle";

        if (action.error.message === "Failed to fetch") {
          state.isOffline = true;
        }
      })
      .addCase(PipelinesListFetcher.fulfilled, (state, action) => {
        state.pipelinesList = action.payload;
      });
  },
});

export const {
  setShowSignUpPopup,
  setUserLoading,
  setUserLoggedInData,
  setisUserLogin,
  setisAdminLogin,
  setSelectedPipelineId,
  setPipelineAutoSelectResolved,
} = userSlice.actions;

export default userSlice.reducer;
